module.exports = __webpack_public_path__ + "img/banking.ebba54da.jpg";